import script from "./VoucherCategories.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherCategories.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherCategories.vue?vue&type=style&index=0&id=3eca5e2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eca5e2d"]])

export default __exports__